import { createAction } from '@reduxjs/toolkit';

export const CONNECT_CRM = 'CONNECT_CRM';
export const connectCrmAction = createAction(CONNECT_CRM);